<template>
  <div class="scene-loading">
    <img class="sprite .hu__hu__" src="/images/game/sprite-1.png" />
    <div class="title">小悦的葡萄酒知识大挑战</div>
    <div class="progress-title">游戏正在加载中…</div>
    <div class="progress-background">
      <div class="percentage" :style="{width: progress + '%'}"></div>
    </div>

    <div v-for="(item, index) in preloadList" :key="index" v-show="false">
      <img :src="item.src" @load="onLoad" v-if="item.type === 'IMAGE'" />
      <audio
        :src="item.src"
        @canplay="onLoad(item)"
        v-else-if="item.type === 'AUDIO'"
        preload
        muted
      />
      <video :src="item.src" @canplaythrough="onLoad" v-else-if="item.type === 'VIDEO'" preload />
    </div>
  </div>
</template>

<script>
import { clearInterval } from "timers";
export default {
  name: "LoadingScene",

  computed: {
    preloadList: function() {
      return this.util.getFileList(this.preload.join(","));
    }
  },
  data() {
    return {
      time: false,
      count: 0,
      progress: 0,
      preload: [
        "/images/game/A-background.png",
        "/images/game/A-result.png",
        "/images/game/A.png",
        "/images/game/B-background.png",
        "/images/game/B-result.png",
        "/images/game/B.png",
        "/images/game/C-result.png",
        "/images/game/C.png",
        "/images/game/S-background.png",
        "/images/game/S-result.png",
        "/images/game/S.png",
        "/images/game/SR-background.png",
        "/images/game/SR-result.png",
        "/images/game/SR.png",
        "/images/game/answer-background.png",
        "/images/game/audio-off.png",
        "/images/game/audio-on.png",
        "/images/game/back.png",
        "/images/game/card-background.png",
        "/images/game/card.png",
        "/images/game/checkpoint-background.png",
        "/images/game/circle.png",
        "/images/game/correct-answer.png",
        "/images/game/correct-dialog.png",
        "/images/game/cp-1-default.png",
        "/images/game/cp-1-hover.png",
        "/images/game/cp-1-subtitle.png",
        "/images/game/cp-1-task.png",
        "/images/game/cp-1-title.png",
        "/images/game/cp-2-default.png",
        "/images/game/cp-2-hover.png",
        "/images/game/cp-2-subtitle.png",
        "/images/game/cp-2-task.png",
        "/images/game/cp-2-title.png",
        "/images/game/cp-2-unlock.png",
        "/images/game/cp-3-default.png",
        "/images/game/cp-3-hover.png",
        "/images/game/cp-3-subtitle.png",
        "/images/game/cp-3-task.png",
        "/images/game/cp-3-title.png",
        "/images/game/cp-3-unlock.png",
        "/images/game/cp-4-default.png",
        "/images/game/cp-4-hover.png",
        "/images/game/cp-4-subtitle.png",
        "/images/game/cp-4-task.png",
        "/images/game/cp-4-title.png",
        "/images/game/cp-4-unlock.png",
        "/images/game/cp-5-default.png",
        "/images/game/cp-5-hover.png",
        "/images/game/cp-5-subtitle.png",
        "/images/game/cp-5-task.png",
        "/images/game/cp-5-title.png",
        "/images/game/cp-5-unlock.png",
        "/images/game/cp-6-default.png",
        "/images/game/cp-6-hover.png",
        "/images/game/cp-6-subtitle.png",
        "/images/game/cp-6-task.png",
        "/images/game/cp-6-title.png",
        "/images/game/cp-6-unlock.png",
        "/images/game/cp-back-button.png",
        "/images/game/cp-card-button.png",
        "/images/game/cp-lift-button.png",
        "/images/game/cp-next-button.png",
        "/images/game/cp-replay-button.png",
        "/images/game/dialog-background-2.png",
        "/images/game/dialog-background.png",
        "/images/game/dialog-left.png",
        "/images/game/dialog-right.png",
        "/images/game/dialog.png",
        "/images/game/fight-success.png",
        "/images/game/gameover-title.png",
        "/images/game/guide-icon.png",
        "/images/game/guide-text.png",
        "/images/game/guide-title.png",
        "/images/game/guide-video-active.png",
        "/images/game/guide-video.png",
        "/images/game/head-background.png",
        "/images/game/left.png",
        "/images/game/logo.png",
        "/images/game/main-top.png",
        "/images/game/menu_arrow.png",
        "/images/game/play-hover.png",
        "/images/game/play.png",
        "/images/game/plot-background.png",
        "/images/game/replay.png",
        "/images/game/result-background.png",
        "/images/game/reward-icon.png",
        "/images/game/right-key.png",
        "/images/game/right.png",
        "/images/game/sprite-1.png",
        "/images/game/sprite-2.png",
        "/images/game/sprite-3.png",
        "/images/game/sprite-4.png",
        "/images/game/sprite-5.png",
        "/images/game/sprite-6.png",
        "/images/game/sprite-7.png",
        "/images/game/sprite-8.png",
        "/images/game/start.png",
        "/images/game/sure.png",
        "/images/game/task-background.png",
        "/images/game/task-fail.png",
        "/images/game/task-finished.png",
        "/images/game/task-reward.png",
        "/images/game/task-unfinished.png",
        "/images/game/text-off.png",
        "/images/game/text-on.png",
        "/images/game/timeout-dialog.png",
        "/images/game/title.png",
        "/images/game/video-off.png",
        "/images/game/video-on.png",
        "/images/game/wine-glass.png",
        "/images/game/wine.png",
        "/images/game/wrong-answer.png",
        "/images/game/梅洛-active.png",
        "/images/game/梅洛-card.png",
        "/images/game/梅洛-default.png",
        "/images/game/西拉-active.png",
        "/images/game/西拉-card.png",
        "/images/game/西拉-default.png",
        "/images/game/赤霞珠-active.png",
        "/images/game/赤霞珠-card.png",
        "/images/game/赤霞珠-default.png",
        "/images/game/长相思-active.png",
        "/images/game/长相思-card.png",
        "/images/game/长相思-default.png",
        "/images/game/雷司令-active.png",
        "/images/game/雷司令-card.png",
        "/images/game/雷司令-default.png",
        "/images/game/霞多丽-active.png",
        "/images/game/霞多丽-card.png",
        "/images/game/霞多丽-default.png",
        "/images/game/黑皮诺-active.png",
        "/images/game/黑皮诺-card.png",
        "/images/game/黑皮诺-default.png",

        "/music/场景5操作音乐（答错）.mp3",
        "/music/场景5操作音乐（答对）.mp3",
        "/music/成绩牌（成功）出来背景音乐.mp3",
        "/music/闯关失败音乐.mp3",
        "/music/答题页背景音乐.mp3",
        "/music/打字.mp3",
        "/music/点击按钮反馈音乐.mp3",
        "/music/兑换礼品卡操作音乐.mp3",
        "/music/解封瞬间音乐.mp3",
        "/music/解封之后背景音乐.mp3",
        "/music/挑战成功后背景音乐.mp3",
        "/music/战斗胜利装酒音乐.mp3",
        "/music/主背景音乐（场景2、3、4）.mp3"
      ]
    };
  },
  async created() {
    await this.loadData();

    setTimeout(this.onTime, 3000);
  },
  methods: {
    async loadData() {
      await this.$store.dispatch("post", {
        packageName: "game",
        className: "gameCheckpoint",
        methodName: "retrieve",
        params: {}
      });

      await this.$store.dispatch("post", {
        packageName: "game",
        className: "common",
        methodName: "getMyBackpack",
        params: {}
      });

      await this.$store.dispatch("post", {
        packageName: "game",
        className: "common",
        methodName: "getMyCheckpoint",
        params: {}
      });

      // this.$store.dispatch("post", {
      //   packageName: "game",
      //   className: "gameQuestion",
      //   methodName: "retrieve",
      //   params: {
      //     numPerPage: 1000
      //   }
      // });
    },
    onGoto() {
      if (this.progress === 100 && this.time) {
        this.$emit("changeScene", this.$store.state.game.currentScene);
      }
    },
    onTime() {
      this.time = true;
      this.onGoto();
    },
    onLoad(item) {
      this.count++;
      const progress = parseInt((this.count / this.preload.length) * 100);
      this.progress = Math.min(progress, 100);
      this.onGoto();
    }
  }
};
</script>


<style lang="scss" scoped>
.scene-loading {
  background: black;
  text-align: center;

  .sprite {
    margin-top: 77px;
    width: 310px;
    height: 311px;

    animation: hu__hu__ infinite 2s ease-in-out;
  }

  @keyframes hu__hu__ {
    50% {
      transform: translateY(5px);
    }
  }

  .title {
    margin-top: -20px;
    font-size: 30px;
    font-family: "FZFMJW";
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
    line-height: 34px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(222, 214, 192, 1) 100%
    );
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .progress-title {
    margin-top: 25px;
    margin-bottom: 15px;
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(228, 200, 150, 1);
    line-height: 20px;
  }

  .progress-background {
    margin: 0 auto;
    width: 400px;
    height: 8px;
    background: rgba(83, 83, 83, 1);
  }

  .percentage {
    width: 0px;
    height: 8px;
    background: linear-gradient(
      270deg,
      rgba(245, 224, 181, 1) 0%,
      rgba(184, 142, 63, 1) 100%
    );
  }
}
</style>